import React from 'react';
import { Divider } from '@mui/material';
import { GlobalSettingsNumberGrid } from '../../../pages/admin/GlobalSettingsNumberGrid';
import { quotaNumberFields } from '../../../pages/admin/global-settings.config';
import { BillingPricingSection } from './BillingPricingSection';
import { SettingsSectionHeader } from './SettingsSectionHeader';
import type { SettingsSectionProps } from './settingsSectionTypes';

export const QuotaBillingSection: React.FC<SettingsSectionProps> = ({ config, onNumberChange }) => (
  <>
    <SettingsSectionHeader
      title="Internal AI task billing"
      description="Internal tasks use metered billing for user work. System jobs without a user are logged and never charged."
    />

    <Divider className="my-6" />

    <SettingsSectionHeader
      title="Quota"
      description="User-facing quota status thresholds shared by API responses and UI badges."
    />
    <GlobalSettingsNumberGrid
      config={config}
      fields={quotaNumberFields}
      columns={3}
      inputProps={{ min: 1, max: 100, step: 1 }}
      onNumberChange={onNumberChange}
    />

    <BillingPricingSection config={config} onNumberChange={onNumberChange} />
  </>
);
